import React from 'react';
import { ChevronRightIcon, CheckCircleIcon } from 'lucide-react';
export function Hero() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex items-center py-6 md:py-0" data-id="element-45">
      <div className="max-w-6xl mx-auto px-4 w-full" data-id="element-46">
        {/* Mobile: stacked layout */}
        <div className="md:hidden flex flex-col items-center text-center" data-id="element-47">
          <h1 className="text-xl font-extrabold text-gray-900 leading-tight mb-4" data-id="element-48">
            DEJÁ DE DEPENDER SOLO DEL CONSULTORIO Y EMPEZÁ A CONSTRUIR UNA
            SALIDA LABORAL REAL
          </h1>
          <img src="https://cdn.magicpatterns.com/uploads/oVDh1soYQXNmmrxQY1rEPC/2(2).png" alt="De Psicólogo a RRHH - Guía Práctica" className="w-[70%] mx-auto cursor-pointer mb-4" onClick={scrollToCompra} data-id="element-49" />
          <h2 className="text-2xl font-bold text-[#1a365d] mb-2" data-id="element-50">
            De Psicólogo a RRHH
          </h2>
          <p className="text-sm text-gray-700 mb-4 px-2" data-id="element-51">
            La guía práctica que te muestra cómo pasar del consultorio al mundo
            corporativo y empezar una nueva etapa profesional con más claridad y
            dirección.
          </p>

          {/* Bullet points */}
          <div className="flex flex-col items-start gap-2 mb-5 w-full px-4" data-id="element-52">
            <div className="flex items-center gap-2" data-id="element-53">
              <CheckCircleIcon className="w-4 h-4 text-amber-500 flex-shrink-0" data-id="element-54" />
              <span className="text-xs text-gray-700" data-id="element-55">
                Ruta clara hacia el mundo laboral corporativo
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-56">
              <CheckCircleIcon className="w-4 h-4 text-amber-500 flex-shrink-0" data-id="element-57" />
              <span className="text-xs text-gray-700" data-id="element-58">
                Herramientas para transformar tu perfil profesional
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-59">
              <CheckCircleIcon className="w-4 h-4 text-amber-500 flex-shrink-0" data-id="element-60" />
              <span className="text-xs text-gray-700" data-id="element-61">
                Estrategias concretas para conseguir entrevistas
              </span>
            </div>
          </div>

          {/* CTA Card */}
          <div className="w-full bg-slate-100 border border-slate-200 rounded-2xl shadow-xl p-5" data-id="element-62">
            <p className="text-[#1a365d] font-bold text-sm mb-3 tracking-wide" data-id="element-63">
              Descargás. Aplicás. Avanzás.
            </p>
            <button onClick={scrollToCompra} className="w-full bg-amber-500 hover:bg-amber-600 text-white font-extrabold py-4 px-6 rounded-xl text-lg transition-all transform hover:scale-105 shadow-lg flex items-center justify-center gap-2 mb-3" data-id="element-64">
              👉 ACCEDER AHORA
              <ChevronRightIcon className="w-6 h-6" data-id="element-65" />
            </button>
            <p className="text-gray-600 text-sm text-center font-medium" data-id="element-66">
              $19.900 ARS · Acceso inmediato
            </p>
          </div>
        </div>

        {/* Desktop: two-column layout */}
        <div className="hidden md:grid md:grid-cols-2 gap-12 items-center" data-id="element-67">
          <div data-id="element-68">
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-extrabold text-gray-900 leading-tight mb-5" data-id="element-69">
              DEJÁ DE DEPENDER SOLO DEL CONSULTORIO Y EMPEZÁ A CONSTRUIR UNA
              SALIDA LABORAL REAL
            </h1>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#1a365d] mb-4" data-id="element-70">
              De Psicólogo a RRHH
            </h2>
            <p className="text-lg lg:text-xl text-gray-700 mb-6" data-id="element-71">
              La guía práctica que te muestra cómo pasar del consultorio al
              mundo corporativo y empezar una nueva etapa profesional con más
              claridad y dirección.
            </p>

            {/* Bullet points */}
            <div className="flex flex-col gap-3 mb-8" data-id="element-72">
              <div className="flex items-center gap-3" data-id="element-73">
                <CheckCircleIcon className="w-5 h-5 text-amber-500 flex-shrink-0" data-id="element-74" />
                <span className="text-gray-700" data-id="element-75">
                  Ruta clara hacia el mundo laboral corporativo
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-76">
                <CheckCircleIcon className="w-5 h-5 text-amber-500 flex-shrink-0" data-id="element-77" />
                <span className="text-gray-700" data-id="element-78">
                  Herramientas para transformar tu perfil profesional
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-79">
                <CheckCircleIcon className="w-5 h-5 text-amber-500 flex-shrink-0" data-id="element-80" />
                <span className="text-gray-700" data-id="element-81">
                  Estrategias concretas para conseguir entrevistas
                </span>
              </div>
            </div>

            {/* CTA Card */}
            <div className="bg-slate-100 border border-slate-200 rounded-2xl shadow-xl p-8 inline-block" data-id="element-82">
              <p className="text-[#1a365d] font-bold text-sm mb-4 tracking-widest" data-id="element-83">
                Descargás. Aplicás. Avanzás.
              </p>
              <button onClick={scrollToCompra} className="bg-amber-500 hover:bg-amber-600 text-white font-extrabold py-5 px-10 rounded-xl text-xl transition-all transform hover:scale-105 shadow-lg flex items-center justify-center gap-3 mb-3" data-id="element-84">
                👉 ACCEDER AHORA
                <ChevronRightIcon className="w-6 h-6" data-id="element-85" />
              </button>
              <p className="text-gray-600 text-base text-center font-medium" data-id="element-86">
                $19.900 ARS · Acceso inmediato
              </p>
            </div>
          </div>
          <div className="flex items-center justify-center" data-id="element-87">
            <img src="https://cdn.magicpatterns.com/uploads/oVDh1soYQXNmmrxQY1rEPC/2(2).png" alt="De Psicólogo a RRHH - Guía Práctica" className="w-full max-w-sm mx-auto cursor-pointer hover:scale-105 transition-transform" onClick={scrollToCompra} data-id="element-88" />
          </div>
        </div>
      </div>
    </section>;
}